import { Navigate, useParams } from 'react-router-dom';

/**
 * F5-T6c · Admin 12 — el detalle del lote deja de ser tercera pantalla (el
 * contrato lo abre INLINE debajo de la lista, para revisar tres lotes
 * seguidos sin perder el hilo). La ruta /admin/batches/:id se conserva
 * (AdminShell no se toca en esta tanda) y redirige a la fusión con el lote
 * abierto. El contenido conservado del detalle viejo (breakdown de estados,
 * reparto por agente, notas, hash) vive demotado dentro del detalle inline.
 */
export function BatchDetailPage(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={id ? `/admin/batches?open=${encodeURIComponent(id)}` : '/admin/batches'} replace />;
}
